import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import resetIcon from '/resetIcon.svg';

interface ResetButtonProps {
  onReset: () => void;
}

const ResetButton: FC<ResetButtonProps> = ({ onReset }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center font-medium text-primary md:mb-0">
      <div className="cursor-pointer flex items-center" onClick={onReset}>
        <span className="mr-3">
          <img src={resetIcon} alt="" />
        </span>
        {t('resetData')}
      </div>
    </div>
  );
};

export default ResetButton;
